import {
  AuthMachine_GetUserDocument,
  AuthProvider_UserFragment,
} from '@/graphql';
import { getClient } from '@/utils/apolloClient';
import { logger } from '@/utils/logger';

/**
 * Checks if a user exists in the database by phone number
 * @param phoneNumber The phone number to check
 * @returns Object containing user existence and ID if found
 */
const getUser = async (
  userId: string,
): Promise<{ user: AuthProvider_UserFragment | null }> => {
  try {
    const client = getClient();

    const { data } = await client.query({
      query: AuthMachine_GetUserDocument,
      variables: { userId },
      fetchPolicy: 'network-only', // Don't use cache for this security-sensitive check
    });

    const user = data?.usersByPk ?? null;

    return { user };
  } catch (error) {
    logger.error(`Error checking user by phone: ${error}`);
    // Fail gracefully - treat as if user doesn't exist
    return { user: null };
  }
};

export { getUser };
